import type { RootState } from 'store'

export const getPolicyBannerStrings = (state: RootState) =>
  state.strings.policyBanner

export const getGeneralStrings = (state: RootState) => state.strings.general

export const getLoginButtonStrings = (state: RootState) =>
  state.strings.loginButton

export const getLoginFormStrings = (state: RootState) => state.strings.loginForm

export const getRegisterFormStrings = (state: RootState) =>
  state.strings.registerForm

export const getCommentLabelTextString = (state: RootState) => {
  const { commentLabelText } = getGeneralStrings(state)
  return commentLabelText
}

export const getArticleHeaderStrings = (state: RootState) => {
  return state.strings.components.articleHeader
}

export const getSocialStrings = (state: RootState) => {
  return state.strings.social
}

export const getDaysOfWeekStrings = (state: RootState) => {
  const { daysOfWeek } = getGeneralStrings(state)
  return daysOfWeek
}

export const getWodStrings = (state: RootState) => {
  return state.strings.components.workoutOfTheDay
}

export const getResumeCourseBannerStrings = (state: RootState) => {
  return state.strings.components.resumeCourseBanner
}

export const getCommentStrings = (state: RootState) => {
  return state.strings.comments
}

export const getTrainingLanguageStrings = (state: RootState) => {
  return state.strings.components.trainingLanguageStrings
}
